// Поповер: shadcn 4.21.1 (base-mira, Base UI), подогнан под ui-spec §4–§5 (задача D5):
// - панель --popover с рамкой --border и тенью --shadow-pop (тени — только у поповера и окна), текст 13/18;
// - раскрывается от кнопки: класс .pop из motion.css (opacity + scale .97 от --transform-origin, 160 / 110 мс);
//   анимации tw-animate-css (сдвиг и масштаб 95 %) и кольцо 1 px убраны;
// - Esc и щелчок мимо закрывают, фокус возвращается на кнопку (Base UI).
import { Popover as PopoverPrimitive } from '@base-ui/react/popover';
import { cn } from 'cn';
import type * as React from 'react';

function Popover({ ...props }: PopoverPrimitive.Root.Props) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger({ ...props }: PopoverPrimitive.Trigger.Props) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

function PopoverContent({
  className,
  align = 'center',
  alignOffset = 0,
  side = 'bottom',
  sideOffset = 6,
  ...props
}: PopoverPrimitive.Popup.Props &
  Pick<PopoverPrimitive.Positioner.Props, 'align' | 'alignOffset' | 'side' | 'sideOffset'>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Positioner
        align={align}
        alignOffset={alignOffset}
        side={side}
        sideOffset={sideOffset}
        className="isolate z-50"
      >
        <PopoverPrimitive.Popup
          data-slot="popover-content"
          className={cn(
            'pop z-50 flex w-72 max-w-[calc(100vw-1rem)] flex-col gap-3 rounded-lg border border-border bg-popover p-3 text-base text-popover-foreground shadow-pop outline-none',
            className,
          )}
          {...props}
        />
      </PopoverPrimitive.Positioner>
    </PopoverPrimitive.Portal>
  );
}

function PopoverHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="popover-header" className={cn('flex flex-col gap-0.5', className)} {...props} />;
}

function PopoverTitle({ className, ...props }: PopoverPrimitive.Title.Props) {
  return (
    <PopoverPrimitive.Title data-slot="popover-title" className={cn('text-base font-semibold', className)} {...props} />
  );
}

function PopoverDescription({ className, ...props }: PopoverPrimitive.Description.Props) {
  return (
    <PopoverPrimitive.Description
      data-slot="popover-description"
      className={cn('text-sm text-muted-foreground', className)}
      {...props}
    />
  );
}

export { Popover, PopoverContent, PopoverDescription, PopoverHeader, PopoverTitle, PopoverTrigger };
